module.exports = __webpack_public_path__ + "img/weather_icon.2e4236e3.png";